import * as React from 'react';
import './Styles.scss';
import { JSX } from 'react';
import { BaseComponent } from '../../Core/BaseComponent/BaseComponent';

export class HelperText extends BaseComponent<IHelperTextProps, IHelperTextState>
{
    public render(): JSX.Element
    {
        const classNames: string[] = [];
        classNames.push('helper-text');
        classNames.push(this.props.error ? 'helper-text--error' : '');
        const className = classNames.filter(i => !!i).join(' ');

        return <div className={className}>{this.props.children}</div>
    }
}

export interface IHelperTextProps
{
    error: boolean;
    children: React.ReactNode;
}

export interface IHelperTextState
{
}
